import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sophia Carter',
      text: 'Yoga has improved my flexibility and helped me feel calmer every day.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150'
    },
    {
      name: 'Daniel Wilson',
      text: 'The trainers are incredibly supportive, and every session leaves me feeling refreshed.',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150'
    },
    {
      name: 'Emma Thomas',
      text: 'A peaceful environment with wonderful instructors. I truly enjoy every class.',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150'
    },
    {
      name: 'Olivia Brown',
      text: 'The meditation sessions have helped me reduce stress and sleep much better.',
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        
        <motion.div 
          className="testimonials-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="testimonials-subtitle">TESTIMONIALS</h4>
          <h2 className="testimonials-title">What Our Members Say</h2>
          <p className="testimonials-desc">
            Real stories from people who have transformed their lives through yoga.
          </p>
          <div className="testimonials-divider"></div>
        </motion.div>

        <motion.div 
          className="testimonials-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {testimonials.map((testi, idx) => (
            <motion.div key={idx} className="testimonial-card" variants={itemVariants}>
              <div className="testimonial-profile-img">
                <img src={testi.image} alt={testi.name} />
              </div>
              <div className="testimonial-stars">
                <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
              </div>
              <h3 className="testimonial-name">{testi.name}</h3>
              <p className="testimonial-text">"{testi.text}"</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
